import React, { Component } from 'react';
import './Popup.css';

export default class Popup extends Component {
  constructor() {
    super();
    this.state = {
      canShow:false
    }
  }
  componentDidMount = () => {
    setTimeout(() => {
       this.setState({canShow:true})
    }, 1)
  };
	_classes = () => {
		let classes = 'g-popup ';
		if (this.props.show && this.state.canShow) {
			classes += ' show ';
		}else{
      classes += ' hide ';
    }
		return classes + (this.props.className || '');
	};

	_onClose = () => {
		if (this.props.preventCloseFromBackground) return;
		this.props.onClose();
	};

	render() {
		return (
			<div className={this._classes()} role={this.props.role} aria-modal="true">
				<div className="g-background" onClick={this._onClose} />
				{this.props.children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/popup/Popup.jsx